import { Skeleton, Stack, useTheme } from "@mui/material";
import type { FC } from "react";
import { EventRowSkeleton } from "web_myplann/Activities/Components/EventRowSkeleton";

type Props = {
	rowKeys: ReadonlyArray<string>;
};

export const ActivitiesListSectionSkeleton: FC<Props> = ({ rowKeys }) => {
	const { spacingTokens } = useTheme();

	return (
		<Stack>
			<Stack px={spacingTokens.lg} pt={2.4} pb={spacingTokens.sm}>
				<Skeleton variant="text" width={120} height={14} animation="wave" />
			</Stack>
			<Stack bgcolor="background.paper">
				{rowKeys.map((key, index) => (
					<EventRowSkeleton
						key={key}
						showDivider={index < rowKeys.length - 1}
					/>
				))}
			</Stack>
		</Stack>
	);
};
